import { EquipmentType } from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'equipment-type';

export class EquipmentTypeController extends BaseHttpController {
  constructor() {
    super(endpoint, { canIncludeSubDomains: true });
  }

  async findAllTypes(): Promise<EquipmentType[]> {
    const response = await this.http.get<EquipmentType[]>('');
    return response.data.map((val) => new EquipmentType(val));
  }

  async findUsedTypes(): Promise<EquipmentType[]> {
    const response = await this.http.get<EquipmentType[]>('used');
    return response.data.map((val) => new EquipmentType(val));
  }
}
